import {
  DeleteOutlineOutlined,
  EditOutlined,
  PublicOutlined,
} from "@mui/icons-material";
import {
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";

// Card de um item do catálogo do Flow (CDN ou classe de tráfego): mostra o
// ícone/cor cadastrados e a condição SQL usada na classificação.
export default function ItemCard({ item, corInfo, onEditar, onExcluir }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Paper variant="outlined" sx={styles.card}>
      <Box sx={styles.header}>
        <Box sx={{ ...styles.iconWrapper, backgroundColor: corInfo?.valor }}>
          {item.icone ? (
            <Box
              component="img"
              src={item.icone}
              alt={item.identificador}
              sx={styles.iconImage}
            />
          ) : (
            <PublicOutlined sx={styles.icon} />
          )}
        </Box>

        <Box sx={styles.titleBox}>
          <Typography sx={styles.title} noWrap>
            {item.identificador}
          </Typography>
          <Typography sx={styles.subtitle} noWrap>
            {item.tipo === "cdn" ? "CDN" : "Classe de tráfego"}
          </Typography>
        </Box>

        <Box sx={styles.actions}>
          <Tooltip title="Editar">
            <IconButton size="small" onClick={() => onEditar(item)}>
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton size="small" onClick={() => onExcluir(item)}>
              <DeleteOutlineOutlined fontSize="small" color="error" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Divider sx={styles.divider} />

      <Box component="pre" sx={styles.condicao}>
        {item.condicao}
      </Box>
    </Paper>
  );
}
